import React from 'react';
import './slider-foamstop-pu-bass.css';
import Basstrap1 from '../../images/basstrap1.webp';
import Basstrap2 from '../../images/basstrap2.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-foamstop-pu-bass">
		<div id="carouselExampleIndicators5" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators5" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators5" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Basstrap1} alt="Basstrap1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>BASS TRAP DESIGN</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Basstrap2} alt="Basstrap2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>BASS TRAP DESIGN</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators5" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators5" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;